import React from 'react'
import { getRequiredError, IField } from './FieldValidation';
import { FormItem, FormItemProps } from './FormItem';
import { Option } from './Options';
import { ErrorText } from ".";
import ReactTooltip from "react-tooltip";

export interface ButtonFieldProps<V> extends FormItemProps {
    id: string
    block?: boolean
    onChange: { (value: V): any },
    value: V,
    dataSource: Option<V>[],
    required?: boolean
    requiredMessage?: string
    disabled?: boolean
    enforceValue?: V
}

export interface ButtonFieldState {
    errorText?: string
}

export class ButtonField<V> extends React.Component<ButtonFieldProps<V>, ButtonFieldState> implements IField {
    inputs: { [value: string]: HTMLButtonElement }

    constructor(props?: ButtonFieldProps<V>, context?: any) {
        super(props, context);

        this.inputs = {};

        this.state = {
        };
    }

    componentDidUpdate(prevProps: ButtonFieldProps<V>, prevState: ButtonFieldState) {
        if (this.props.value != prevProps.value) {
            if (this.state.errorText) {
                this.validate(() => { });
            }
        }
    }

    render() {

        if (this.props.preview) {
            return <FormItem {...this.props} errorMessage={this.state.errorText}>
                {this.props.dataSource.filter(r => r.value == this.props.value).map((d, i) => <div className="form-value" key={i}>{d.label}</div>)}
            </FormItem>
        }

        let items: JSX.Element[] = [];
        if (this.props.dataSource) {
            items = this.props.dataSource.map((d, i) => {
                let inputId = this.props.id + "_" + i;
                return <div key={i} className={
                    `emdg-control-input ml-3` +
                    `${this.props.block ? ' emdg-control-input--block' : ''}` +
                    `${this.state.errorText ? ' emdg-control-input--invalid' : ''}` +
                    `${this.props.className ? (' ' + this.props.className) : ''}`
                }>
                    <button
                        ref={r => this.inputs[(d.value as any).toString()] = r}
                        id={inputId}
                        name={this.props.id}
                        value={(d.value as any).toString()}
                        className={
                            `emdg-btn` +
                            `${d.value == this.props.value ? '' : ' emdg-btn--secondary'}`}
                        onClick={() => this.props.onChange(d.value)}
                        disabled={this.props.disabled}>
                        {d.label}
                    </button>
                </div>
            });
        }

        let style: any;
        if (this.props.visible === false) {
            style = { display: "none" };
        }

        return <div style={style} className="container-fluid form-item">
            <div className="row">
                <div className="col-md-8 pl-0">
                    <label className="form-label" htmlFor={this.props.id}>{this.props.required ? <span>{this.props.label}&nbsp;*</span> : this.props.label} {this.props.help ? <a className="far fa-question-circle" data-for={`${this.props.id}-help`} data-tip onClick={e => { e.stopPropagation(); e.preventDefault(); }}></a> : <></>}</label>
                </div>
                <div className="col-md-4 pl-0 pr-0">
                    {items}
                    <ErrorText text={this.state.errorText} className="ml-3" />
                </div>
            </div>
            {this.props.help ? <ReactTooltip className='aus-tooltip' delayHide={500} effect='solid' getContent={tip => this.props.help} id={`${this.props.id}-help`} globalEventOff='click' /> : <></>}
        </div>
    }

    focus() {
        let key = this.props.value ? (this.props.value as any).toString() : null;
        if (key in this.inputs) {
            if (this.inputs[key]) {
                this.inputs[key].focus();
                return;
            }
        }

        key = (this.props.dataSource[0].value as any).toString();
        if (key in this.inputs) {
            if (this.inputs[key]) {
                this.inputs[key].focus();
                return;
            }
        }
    }

    hasValue(): boolean {
        return this.getSource(this.props.value) != null;
    }

    getSource(value: V): Option<V> {
        if (this.props.dataSource) {
            for (let data of this.props.dataSource) {
                if (data.value == value) {
                    return data;
                }
            }
        }

        return null;
    }

    getErrorText(): string {
        if (this.props.required === true) {
            if (!this.hasValue()) {
                return getRequiredError(this.props);
            }

            if (this.props.enforceValue) {
                let source = this.getSource(this.props.enforceValue);
                if (source != null && this.props.value != this.props.enforceValue) {
                    return `You must select "${source.label}" to proceed.`;
                }
            }
        }
        return null;
    }

    validate(callback: { (res: boolean): any }, focus?: boolean) {
        let errorTest = this.getErrorText();
        this.setError(errorTest, () => {
            if (errorTest) {
                if (focus === true) {
                    this.focus();
                }
            }
            callback && callback(errorTest ? false : true);
        })
    }

    setError(errorText?: string, callback?: { (): any }) {
        this.setState({ errorText }, callback);
    }
}

export class NumericButtonField extends ButtonField<number> {
}

export class BooleanButtonField extends ButtonField<boolean> {
}
